import { render, staticRenderFns } from "./CourierStatusForm.vue?vue&type=template&id=a197f768"
import script from "./CourierStatusForm.vue?vue&type=script&lang=js"
export * from "./CourierStatusForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports